import React from "react";
import { Button } from "react-bootstrap";
import { bootstrapUtils } from "react-bootstrap/lib/utils";
import DateTimePicker from "react-datetime";

bootstrapUtils.addStyle(Button, "light-blue");

function RoundNew(props) {
  const { round_number, round, onChange, onAdd } = props;

  return (
    <tr>
      <td className="text-center v-align-middle instructor-round-number b-r">
        {round_number}
      </td>
      <td className="b-l b-r">
        <DateTimePicker
          dateFormat="MM/DD/YYYY"
          timeFormat={false}
          inputProps={{
            placeholder: "Date: MM/DD/YYYY",
            className: "form-control instructor-datetime-control"
          }}
          value={round.start_date}
          onChange={dt => onChange(dt, "start_date")}
        />
        <DateTimePicker
          dateFormat={false}
          timeFormat="hh:mm A"
          inputProps={{
            placeholder: "Time: HH:MM AM/PM",
            className: "form-control instructor-datetime-control"
          }}
          value={round.start_date}
          onChange={dt => onChange(dt, "start_date")}
        />
      </td>
      <td className="b-l b-r">
        <DateTimePicker
          dateFormat="MM/DD/YYYY"
          timeFormat={false}
          inputProps={{
            placeholder: "Date: MM/DD/YYYY",
            className: "form-control instructor-datetime-control"
          }}
          value={round.end_date}
          onChange={dt => onChange(dt, "end_date")}
        />
        <DateTimePicker
          dateFormat={false}
          timeFormat="hh:mm A"
          inputProps={{
            placeholder: "Time: HH:MM AM/PM",
            className: "form-control instructor-datetime-control"
          }}
          value={round.end_date}
          onChange={dt => onChange(dt, "end_date")}
        />
      </td>
      <td className="b-l">
        <Button bsStyle="light-blue" onClick={() => onAdd(round_number)} block>
          Add
        </Button>
      </td>
    </tr>
  );
}

export default RoundNew;



// WEBPACK FOOTER //
// ./src/instructor/components/round-new.js